var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDistributor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 60V41.6576L10.8288 48.8288L8 46L20 34L32 46L29.1712 48.8288L22 41.6576V60H46V64H22C20.9397 63.9983 19.9232 63.5763 19.1734 62.8266C18.4237 62.0768 18.0017 61.0603 18 60Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54H64C65.0606 54.0008 66.0775 54.4225 66.8275 55.1725C67.5775 55.9225 67.9992 56.9394 68 58V66C67.9992 67.0606 67.5775 68.0775 66.8275 68.8275C66.0775 69.5775 65.0606 69.9992 64 70H56C54.9394 69.9992 53.9225 69.5775 53.1725 68.8275C52.4225 68.0775 52.0008 67.0606 52 66V58C52.0008 56.9394 52.4225 55.9225 53.1725 55.1725C53.9225 54.4225 54.9394 54.0008 56 54ZM64 66V58H56V66H64Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22V40.3424L69.1712 33.1712L72 36L60 48L48 36L50.8288 33.1712L58 40.3424V22H34V18H58C59.0603 18.0017 60.0768 18.4237 60.8266 19.1734C61.5763 19.9232 61.9983 20.9397 62 22Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 22H12V26H24V22Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H12V18H28V14Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDistributor);
export default __webpack_public_path__ + "static/media/noDistributor.43977a1b10d455a45d87ef2257d8c5ce.svg";
export { ForwardRef as ReactComponent };